module.exports = __webpack_public_path__ + "img/account-04.5185bf08.png";